import {AfterViewInit, Component, OnChanges, OnInit, ViewChild, SimpleChanges} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {NotifierService} from 'angular-notifier';
import {ErrorHelper} from 'src/app/common/ErrorHelper';
import {ApiService} from 'src/app/services/api.service';

@Component({
  selector: 'app-batch-summary',
  templateUrl: './batch-summary.component.html',
  styleUrls: ['./batch-summary.component.css']
})
export class BatchSummaryComponent implements OnInit {

  @ViewChild(MatSort, { static: false }) sort: MatSort;

  displayedColumns: string[] = ['jobName', 'jobStatus', 'function', 'createdAt', 'startedAt', 'stoppedAt'];
  dataSource: MatTableDataSource<BatchSummary>;

  constructor(private apiService: ApiService,
              private notifierService: NotifierService) {
    this.loadBatchSummaryAsync();
  }

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource();
  }

  async loadBatchSummaryAsync(): Promise<any> {
    try {
      await this.loadBatchSummary();
    } catch (error) {
      console.log(error);
    }
  }

  loadBatchSummary(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      return this.apiService.getBatchSummary().toPromise().then(
        (data) => {
          const batchSummary = data;
          this.dataSource = new MatTableDataSource(batchSummary);
          setTimeout(() => {
            this.dataSource.sort = this.sort;
          });
          console.log('Fetched the batch summary');
          resolve(true);
        },
        (error) => {
          const errorMessage = ErrorHelper.disectError('load batch summary', error);
          this.notifierService.notify('error', errorMessage);
          resolve(false);
        });
    });
  }

}

export interface BatchSummary {
  jobName: string;
  jobStatus: string;
  function: string;
  createdAt: Date;
  startedAt: Date;
  stoppedAt: Date;
}
